<template>
  <div>
    <v-dialog
      v-model="show_access_code_dialog"
      persistent
      :overlay-opacity="1"
      overlay-color="secondary"
      :max-width="400"
    >
      <v-card>
        <v-card-title class="blue white--text">Access restricted</v-card-title>
        <v-card-text class="py-6">
          <v-text-field
            v-model="access_code"
            type="text"
            id="portal-password"
            label="Enter access code"
            autocomplete="off"
            hide-details
            v-on:keyup.enter="load"
          ></v-text-field>

          <div class="text-center pt-3">
            <span v-if="access_code_invalid" class="error--text"
              >Invalid access code</span
            >
          </div>
        </v-card-text>
        <v-card-actions class="grey lighten-4">
          <v-btn text to="/">Go Home</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue" dark @click="load" :disabled="!access_code"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="show_error_dialog"
      persistent
      :overlay-opacity="1"
      overlay-color="secondary"
      :max-width="400"
    >
      <v-card>
        <v-card-title class="primary white--text">
          Link unavailable
          <v-spacer></v-spacer>
          <v-icon dark>fa-exclamation-triangle</v-icon>
        </v-card-title>
        <v-card-text class="py-6">
          <div class="text-center pt-3">
            <h3 class>{{ error_message }}</h3>
          </div>
        </v-card-text>
        <v-card-actions class="grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn text to="/">Go Home</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay absolute :opacity="0.75" v-if="loading">
      <div class="text-center">
        <v-progress-circular :size="100" indeterminate></v-progress-circular>
        <div class="caption mt-4">Loading</div>
      </div>
    </v-overlay>

    <transition name="slide-x-reverse-transition">
      <v-container class="py-0">
        <v-row justify="center">
          <v-col cols="12" lg="12" xl="9">
            <v-container class="pa-0 pt-8" v-if="!loading">
              <v-row justify="center" style="position: relative">
                <v-col
                  cols="12"
                  sm="11"
                  md="10"
                  lg="9"
                  xl="7"
                  class="text-center"
                >
                  <img :src="logo.url" v-if="logo" style="width: 100%" />
                </v-col>
              </v-row>
              <v-row align="center" justify="center" class="mb-4">
                <v-col
                  cols="10"
                  sm="6"
                  md="4"
                  lg="3"
                  xl="3"
                  order="2"
                  order-md="1"
                >
                  <v-text-field
                    label="Search"
                    append-icon="fa-search"
                    hide-details
                    clearable
                    v-model="search"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  lg="6"
                  xl="6"
                  class="text-center"
                  order="1"
                  order-md="2"
                >
                  <div class="d-flex justify-center align-center">
                    <h2 v-if="!logo" class="secondary--text">Portals</h2>
                  </div>
                </v-col>
                <v-col
                  cols="10"
                  sm="6"
                  md="4"
                  lg="3"
                  xl="3"
                  order="3"
                  order-md="3"
                >
                  <v-select
                    label="Sort by"
                    v-model="sort_by"
                    hide-details
                    :items="sort_options"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row
                align="center"
                :justify="
                  $vuetify.breakpoint.name === 'xs' ? 'center' : 'start'
                "
                v-if="computedItems.length"
              >
                <v-col
                  cols="10"
                  sm="6"
                  md="4"
                  lg="3"
                  xl="3"
                  v-for="(item, i) in computedItems"
                  :key="i"
                  class="pa-4"
                >
                  <portal-card
                    :item="item"
                    :to="`/viewer-link/${item.uid}`"
                  ></portal-card>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </transition>
  </div>
</template>

<script>
import portalCard from "@/components/portal/viewer/card";

export default {
  name: "LibraryView",
  components: { portalCard },
  data() {
    return {
      loading: false,
      access_code: "",
      access_code_required: false,
      access_code_invalid: false,
      show_access_code_dialog: false,
      sort_by: "Newest",
      sort_options: ["Newest", "Oldest", "Applicants", "Visits"],
      error_message: "",
      show_error_dialog: false, //Shows a popup saying the portal is unavailable. (user account is bad or portal isnt active)
      portals: [],
      user: {},
      logo: null,
      search: "",
    };
  },
  watch: {
    sort_by: function () {
      this.sortItems(this.portals);
      localStorage.setItem("sort_by", this.sort_by);
    },
  },
  computed: {
    computedItems() {
      if (this.search) {
        return this.portals.filter(
          function (i) {
            if (
              i.name &&
              i.name.toLowerCase().includes(this.search.toLowerCase())
            ) {
              return true;
            }
            if (
              i.title &&
              i.title.toLowerCase().includes(this.search.toLowerCase())
            ) {
              return true;
            }
            return false;
          }.bind(this)
        );
      } else {
        return this.portals;
      }
    },
  },
  created() {
    this.load();
  },
  methods: {
    sortItems(items) {
      items.sort(
        function (a, b) {
          if (this.sort_by === "Newest") {
            if (a.id > b.id) {
              return -1;
            } else {
              return 1;
            }
          } else if (this.sort_by === "Oldest") {
            if (a.id > b.id) {
              return 1;
            } else {
              return -1;
            }
          } else if (this.sort_by === "Applicants") {
            if (a.applicants > b.applicants) {
              return -1;
            } else {
              return 1;
            }
          } else if (this.sort_by === "Visits") {
            if (a.visits > b.visits) {
              return -1;
            } else {
              return 1;
            }
          } else {
            return 0;
          }
        }.bind(this)
      );
    },
    async load() {
      this.loading = true;
      this.access_code_invalid = false;

      try {
        let response = await this.$api(
          `/viewer/library/${this.$route.params.uid}?access_code=${this.access_code}`
        );
        if (response.access_code_required) {
          this.access_code_required = true;
          this.show_access_code_dialog = true;
          if (response.access_code_invalid) {
            this.access_code = "";
            this.access_code_invalid = true;
          }
        } else {
          this.portals = response.portals;
          this.user = response.user;
          this.logo = response.logo || null;
          this.show_access_code_dialog = false;
        }
      } catch (ex) {
        this.error_message = ex.error;
        this.show_error_dialog = true;
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>